import { render, staticRenderFns } from "./Infoauto.vue?vue&type=template&id=027bed58"
import script from "./Infoauto.vue?vue&type=script&lang=js"
export * from "./Infoauto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports